import React from 'react';

export default (props) => (
  <svg className={props.className} width="8" height="18" xmlns="http://www.w3.org/2000/svg" >
    <g>
      <path d="M 4 0 L 0 6 L 3 6 L 3 18 L 5 18 L 5 6 L 8 6 L 4 0 z" />
    </g>
  </svg>
);


// WEBPACK FOOTER //
// ./src/components/svg/up_arrow.js